import { z } from "zod";

export const mediaUploadResultSchema = z.object({
  id: z.string(),
  deduplicated: z.boolean(),
  url: z.string(),
  optimized: z.boolean(),
  original_size: z.number(),
  stored_size: z.number(),
  saved_bytes: z.number(),
  savings_percent: z.number(),
  mime_type: z.string(),
  width: z.number().nullable(),
  height: z.number().nullable(),
});

export type MediaUploadResult = z.infer<typeof mediaUploadResultSchema>;

export function formatUploadBytes(value: number) {
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${Math.ceil(value / 1024)} KB`;
  return `${(value / (1024 * 1024)).toFixed(1)} MB`;
}

export function mediaUploadDescription(result: MediaUploadResult) {
  if (result.optimized) {
    const dimensions = result.width && result.height
      ? ` · ${result.width}×${result.height} px`
      : "";
    const savings = result.saved_bytes > 0
      ? ` · %${result.savings_percent.toLocaleString("tr-TR")} daha küçük`
      : " · WebP olarak normalize edildi";
    return `${formatUploadBytes(result.original_size)} → ${formatUploadBytes(result.stored_size)}${savings}${dimensions}`;
  }
  if (result.deduplicated) return "Bu dosya medya kütüphanesinde zaten bulunuyor.";
  return `${formatUploadBytes(result.stored_size)} olarak kaydedildi.`;
}
